import React, { Component } from 'react'
import { graphql } from 'gatsby'

import Seo from '../components/seo'

import RenderBlock from '../utils/render-block'

class PageTemplate extends Component {

  render() {
    const { wpPage } = this.props.data

    return (
      <>
        <Seo bodyClass={`page-template page-template--${wpPage.slug}`} {...wpPage.seo} />
        { wpPage.acf?.contentBlocks?.map((el, i) => RenderBlock(el.fieldGroupName?.replace('page_Acf_ContentBlocks_', ''), el, i))  }
      </>
    )
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    wpPage(id: {eq: $id}) {
      title
      slug
      uri
      seo {
        ...WpSeo
      }
      acf {
        contentBlocks {
         ... on WpPage_Acf_ContentBlocks_Reviews {
          fieldGroupName
          subtitle
          title
          reviews {
            ... on WpReview {
              id
              content
              title
              uri
              slug
            }
          }
          greenBackground
        }
          ... on WpPage_Acf_ContentBlocks_LandingBanner {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2400)
                }
              }
              altText
            }
            video
            title
            link
            showSearch
          }
          ... on WpPage_Acf_ContentBlocks_Services {
            fieldGroupName
            title
            subtitle
            services {
              ... on WpPage {
                title
                uri
                acf {
                  excerpt
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_TeamArchive {
            fieldGroupName
            title
            team {
              ... on WpTeam {
                title
                content
                featuredImage {
                  node {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 1200)
                      }
                    }
                    altText
                  }
                }
                acf {
                  position
                  meetingLink
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_CardSlider {
            fieldGroupName
            subtitle
            title
            items {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 600)
                  }
                }
                altText
              }
              title
              content
            }
          }
          ... on WpPage_Acf_ContentBlocks_Awards {
            fieldGroupName
            title
            content
            awards {
              icon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 150)
                  }
                }
                altText
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Stats {
            fieldGroupName
            items {
              value
              label
            }
            negativeMargin
          }
          ... on WpPage_Acf_ContentBlocks_ImageTitleContent {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1600)
                }
              }
              altText
            }
            subtitle
            title
            content
            button {
              url
              title
            }
            reverse
            icon
            h1
            buttonColour
            circleButton
            signature
          }
          ... on WpPage_Acf_ContentBlocks_ServiceBanner {
            fieldGroupName
            title
            backgroundColour
          }
          ... on WpPage_Acf_ContentBlocks_ImageBanner {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2400)
                }
              }
              altText
            }
          }
          ... on WpPage_Acf_ContentBlocks_Image {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2400)
                }
              }
              altText
            }
          }
          ... on WpPage_Acf_ContentBlocks_Faqs {
            fieldGroupName
            subtitle
            title
            items {
              title
              content
            }
          }
          ... on WpPage_Acf_ContentBlocks_Process {
            fieldGroupName
            items {
              title
              content
            }
          }
          ... on WpPage_Acf_ContentBlocks_BasicPage {
            fieldGroupName
            title
            content
          }
          ... on WpPage_Acf_ContentBlocks_Resources {
            fieldGroupName
            title
            items {
              ... on WpPage {
                id
                title
                uri
                acf {
                  label
                  excerpt
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Resource {
            fieldGroupName
            title
            subtitle
            content
            embed
            widgetWorks
            footnote
          }
          ... on WpPage_Acf_ContentBlocks_ContactForm {
            fieldGroupName
            subtitle
            title
            content
            phone {
              url
              title
            }
            email {
              url
              title
            }
            button {
              url
              title
            }
          }
          ... on WpPage_Acf_ContentBlocks_Partners {
            fieldGroupName
            partners {
              link
              logo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 800)
                  }
                }
                altText
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Cta {
            fieldGroupName
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2400)
                }
              }
              altText
            }
            button {
              url
              title
            }
            backgroundColour
          }
        }
      }
    }
  }
`

export default PageTemplate